
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/set-informativi/[slug]",
      function () {
        return require("private-next-pages/set-informativi/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/set-informativi/[slug]"])
      });
    }
  